import { Mobile } from '../core'

$.fn.scrollToAnchor = function(offset = 0) {
  let self = this

  self.click(function() {
    var hash = $(this).attr('href');
    if ($(hash).length) {
      var targetTop = $(hash).offset().top;
      targetTop -= ($.mlmi.mobile.isMobile ? 0 : 0);
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false;
    }
  });

  return function() {
    return self
  }()
};
